import { get } from 'fe-common-xhr'

export type WorkOrder = {
  id: string
  productId: string
  invoiceTime: string | null
  organizationId: string
}

export const getWorkOrder = async (workOrderId: string): Promise<WorkOrder | null> => {
  const { data, status } = await get<WorkOrder>(`/api/workorder/work-orders/${workOrderId}`, {
    validateStatus: (responseStatus) => [200, 404].includes(responseStatus)
  })

  return status === 404 ? null : data
}
